"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmpty = exports.getCurrencySymbolByCode = exports.formatCurrency = exports.formatAsPercent = void 0;

var _currencyFormatter = _interopRequireDefault(require("currency-formatter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var formatAsPercent = function formatAsPercent(number) {
  return (Math.round(number * 100) / 100).toFixed(2);
};

exports.formatAsPercent = formatAsPercent;

var formatCurrency = function formatCurrency(currency) {
  return function (currencyDisplay) {
    return function (value) {
      return currencyDisplay === 'code' ? _currencyFormatter["default"].format(value, {
        code: currency,
        format: "".concat(currency, " %v")
      }) : _currencyFormatter["default"].format(value, {
        code: currency
      });
    };
  };
};

exports.formatCurrency = formatCurrency;

var getCurrencySymbolByCode = function getCurrencySymbolByCode(code) {
  if (!code) {
    return '';
  }

  var currency = _currencyFormatter["default"].findCurrency(code);

  return currency ? currency.symbol : '';
};

exports.getCurrencySymbolByCode = getCurrencySymbolByCode;

var isEmpty = function isEmpty(value) {
  return value === 0;
};

exports.isEmpty = isEmpty;
//# sourceMappingURL=index.js.map